import styled from 'styled-components';
import { SummaryLegalTextStyled } from '@components/SummaryLegalText/SummaryLegalTextStyled';

export const SummaryLegalTextStyledAC = styled(SummaryLegalTextStyled)`
    p {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.grey1};
    }
`;
